import { render, staticRenderFns } from "./ContactsForm.vue?vue&type=template&id=80d8970e&scoped=true&"
import script from "./ContactsForm.vue?vue&type=script&lang=js&"
export * from "./ContactsForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactsForm.vue?vue&type=style&index=0&id=80d8970e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d8970e",
  null
  
)

export default component.exports